import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ element: Element }) => {
  const { isAuthenticated, user, impersonatedSchool, authLoading } = useAuth();

  if (authLoading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // SuperAdmin without impersonation → redirect to platform
  // SuperAdmin with impersonation → allow through to school routes
  if (user?.roleName === 'SuperAdmin' && !impersonatedSchool) {
    return <Navigate to="/platform/dashboard" />;
  }

  return <Element />;
};

export default ProtectedRoute;
